// PHP Database Client - replaces Supabase calls
// All database operations go through /api_php/rpc.php

type QueryBuilder<T = any> = {
  select: (cols?: string) => QueryBuilder<T>;
  insert: (data: any) => QueryBuilder<T>;
  update: (data: any) => QueryBuilder<T>;
  delete: () => QueryBuilder<T>;
  eq: (col: string, val: any) => QueryBuilder<T>;
  order: (col: string, opts?: { ascending?: boolean }) => QueryBuilder<T>;
  single: () => Promise<{ data: T | null; error: any }>;
  then: (resolve: any, reject?: any) => Promise<any>;
};

function getAuthToken(): string | null {
  return localStorage.getItem('auth_token');
}

function createQueryBuilder(table: string): QueryBuilder {
  let action = 'select';
  let columns = '*';
  let filters: any[] = [];
  let orderBy: string | undefined;
  let orderAsc = true;
  let values: any = null;
  let isSingle = false;

  const builder: any = {
    select(cols = '*') {
      action = 'select';
      columns = cols;
      return builder;
    },
    insert(data: any) {
      action = 'insert';
      values = data;
      return builder;
    },
    update(data: any) {
      action = 'update';
      values = data;
      return builder;
    },
    delete() {
      action = 'delete';
      return builder;
    },
    eq(col: string, val: any) {
      filters.push({ column: col, operator: '=', value: val });
      return builder;
    },
    order(col: string, opts?: { ascending?: boolean }) {
      orderBy = col;
      orderAsc = opts?.ascending ?? true;
      return builder;
    },
    single() {
      isSingle = true;
      return builder;
    },
    then(resolve: any, reject?: any) {
      const promise = (async () => {
        try {
          const token = getAuthToken();
          const response = await fetch('/api_php/rpc.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            },
            body: JSON.stringify({
              fn: 'query',
              args: {
                table,
                action,
                columns,
                filters,
                order: orderBy,
                orderAsc,
                values,
                single: isSingle
              }
            })
          });

          if (!response.ok) {
            const error = await response.json().catch(() => ({ message: 'Request failed' }));
            return { data: null, error };
          }

          const result = await response.json();
          return { data: result.data ?? null, error: null };
        } catch (err: any) {
          return { data: null, error: err };
        }
      })();

      return promise.then(resolve, reject);
    }
  };

  return builder;
}

export const db = {
  from: (table: string) => createQueryBuilder(table),
  
  // Storage placeholder (not implemented yet)
  storage: {
    from: (bucket: string) => ({
      createSignedUrl: async (path: string, expiresIn: number) => {
        return { data: null, error: { message: 'Storage not implemented' } };
      }
    })
  }
};
